export { getIconsDisplayData } from './get-icons-display-data';
